import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { FeatureToggleService } from '../services/feature-toggle.service';
import { FeatureToggleModele } from '../modeles/feature-toggle.modele';

@Directive({
  exportAs: 'featureToggle',
  // tslint:disable-next-line:directive-selector
  selector: 'featureToggle, [featureToggle]',
  standalone: false
})
export class FeatureToggleDirective implements OnInit {
  @Input() featureToggle: FeatureToggleModele;
  @Input() featureToggleOr: FeatureToggleModele;

  constructor(
    private readonly _featureToggleService: FeatureToggleService,
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    if (this.isEnabled()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  isEnabled() {
    return (
      this._featureToggleService.hasFeatures(this.featureToggle) ||
      this._featureToggleService.hasFeatures(this.featureToggleOr)
    );
  }
}
